import { memo, useEffect } from "react";
import { connect } from "react-redux";
import { ProcedimentoViewProps, mapDispatchToProcedimentoProps, mapStateToProcedimentoProps } from "../procedimento.controller";
import { Autocomplete, Box, IconButton, Stack, TextField, Typography } from "@mui/material";
import { Procedimento } from "../procedimento.model";
import { ArrowDropDown, Search } from "@mui/icons-material";
import { ClearIcon } from "@mui/x-date-pickers";
import Modal from "../../../components/modal";
import { columnsProcedimento } from "./procedimento.list";
import { Select as ViewList } from "../../../components/select";
import { ProcedimentoCadastro } from "./procedimento.cad";


interface ProcedimentoAutoCompletProps extends ProcedimentoViewProps {
    handleSelectProcedimento: (row: Procedimento) => any
}


function ProcedimentoAutoComplete(props: ProcedimentoAutoCompletProps) {
    const { procedimentoActions,procedimentoState, handleSelectProcedimento } = props
    const { rows } = procedimentoState
    useEffect(() => {
        console.log("chamou ")
        procedimentoActions.read();
    }, [])

    const handleSelect = (row: Procedimento) => {
        console.log("selecionou procedimentoecedor " + row)
        handleSelectProcedimento(row)
    }

    return (
        <Autocomplete
            fullWidth
            options={rows}
            autoHighlight
            getOptionLabel={(row) => row.descricao}
            getOptionKey={(row) => row._id}
            title="Selecionar Procedimento"
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            disableClearable
            //popupIcon={<Search fontSize="small"  titleAccess="Selecionar Procedimento"/>}
            clearIcon={<ClearIcon fontSize="small" titleAccess="Remover" />}
            renderOption={((props, procedimento) => {
                const { key, ...optionProps } = props
                return (
                    <Box
                        key={key}
                        component={"li"}
                        {...optionProps}
                    >
                        <Stack flexDirection={"column"}>
                            <Typography variant="body1">{procedimento.descricao}</Typography>
                        </Stack>
                    </Box>
                )
            })}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label="Selecionar Procedimento"
                    slotProps={{
                        htmlInput: {
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        },
                    }}
                />
            }
            onChange={(ev, procedimento) => {
                ev.preventDefault();
                if (procedimento)
                    handleSelect(procedimento);
            }}
        />
    )
}
interface SelecionarProcedimentoProps extends ProcedimentoViewProps {
    handleConfirmar: (procedimento: Procedimento) => any;
}

const SelecionarProcedimento = memo((props: SelecionarProcedimentoProps) => {
    const { procedimentoActions,procedimentoState, handleConfirmar } = props
    const { error, loadingRows, msg, row, rows, showAlert, status, showCadModal, changeList, showSelectModal } = procedimentoState
    const { read, setShowAlert, setClearValue, setShowCadModal, setShowSelectModal } = procedimentoActions

    console.log("carregou Selecionar Procedimento")
    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    function Cadastro() {
        return ProcedimentoCadastro({
            ...props,
            handleCloseView: () => setShowCadModal(false)
        }).renderModal({
            handleClose: () => setShowCadModal(false),
            show: showCadModal,
            heigth: "auto",
            width:"sm"
        })
    }

    const handleSelecionar = (procedimento:Procedimento) => {
        handleConfirmar(procedimento);
        setShowSelectModal(false);
    }

    const List = () => {
        return (
            <>
                <ViewList
                    displayWidth={window.innerWidth}
                    title={"Selecionar Procedimento"}
                    row={row}
                    showAlert={showAlert}
                    closeAlert={() => setShowAlert(false)}
                    msg={msg}
                    status={status}
                    elevation={1}
                    getRowId={(row: Procedimento) => row._id}
                    handleOnChange={handleSelecionar}
                    actionsOnkeyEnter={handleSelecionar}
                    showSearchContainer={true}
                    fontSize={20}
                    setTextSearch={() => { }}
                    textSearch={""}
                    fieldSearch={"descricao"}
                    placeholderTextSearch="Buscar procedimento"
                    variantToobar="dense" 
                    columns={columnsProcedimento}
                    rows={rows}
                    loading={loadingRows}
                    setRow={handleSelecionar}
                    changeList={changeList}
                    buttonNew={{
                        show: true,
                        onClick: handleNovo
                    }}
                    buttonRefresh={{
                        show: true,
                        onClick: () => read()
                    }}
                    ListItemTextPrimary={(row: Procedimento) => <Typography component={"span"}>{row.descricao}</Typography>}
                />
                <Cadastro />
            </>
        )
    }

    return (
        <Modal
            component={<List />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            heigth="auto"
            width="xs"
            handleOnKeyDown={() => { }}
        />
    )
},(prev,next)=>{
    return prev.procedimentoState.showSelectModal === next.procedimentoState.showSelectModal&&
    prev.procedimentoState.changeList === next.procedimentoState.changeList
})

export default connect(mapStateToProcedimentoProps, mapDispatchToProcedimentoProps)(ProcedimentoAutoComplete)
export const ViewSelecionarProcedimento = connect(mapStateToProcedimentoProps, mapDispatchToProcedimentoProps)(SelecionarProcedimento)